module.exports = __webpack_public_path__ + "img/Galapagos Islands.aa7dbd48.svg";